import {
  TechDocPage,
  TechDocChecklistPage,
  TechDocWizardPage,
} from '../containers/pages';
import { gettingStarted } from './pageConfigComm';
import {
  DHCI_RACK_VIDEO,
  DHCI_CABLE_STEP1_VIDEO,
  DHCI_SWITCH_CONFIGURE_VIDEO,
  DHCI_CABLE_STEP1_BROWN_VIDEO,
  DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
} from '../constants';
import { ALLETRA6k_VIDEO_URL } from '../constants';

export const dHCI6KPagesConfigExistEnv = [
  ...gettingStarted(),
  {
    path: '/physical-install',
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: '/physical-install/unbox',
    submenuItems: [
      {
        path: '/physical-install/unbox',
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.DHCI_UNBOX,
        },
      },
      {
        path: '/physical-install/rackArray',
        menuText: 'rackArray',
        exact: true,
        redirectTo: '/physical-install/rackArray/1',
      },
      {
        path: '/physical-install/rackArray/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rackArray',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP1,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP2,
            },
            {
              videoUrl: ALLETRA6k_VIDEO_URL.DHCI_RACK_ARRAY_STEP3,
            },
          ],
        },
      },
      {
        path: '/physical-install/rackServersSwitches',
        menuText: 'rackServersSwitches',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: DHCI_RACK_VIDEO,
        },
      },
      {
        path: '/physical-install/cable',
        menuText: 'cable',
        exact: true,
        redirectTo: '/physical-install/cable/1',
      },
      {
        path: '/physical-install/cable/:step',
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl_green: DHCI_CABLE_STEP1_VIDEO,
              videoUrl_brown: DHCI_CABLE_STEP1_BROWN_VIDEO,
            },
            {
              videoUrl_green: '',
              videoUrl_brown: '',
            },
            {
              videoUrl_green: '',
              videoUrl_brown: '',
            },
          ],
        },
      },
      {
        path: '/physical-install/powerOn',
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA6k_VIDEO_URL.DHCI_POWER,
        },
      },
    ],
  },
  {
    path: '/software-config',
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: '/software-config/configSwitchExistEnv',
    submenuItems: [
      {
        path: '/software-config/configSwitchExistEnv',
        menuText: 'configSwitchExistEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl_green: DHCI_SWITCH_CONFIGURE_VIDEO,
          videoUrl_brown: DHCI_SWITCH_CONFIGURE_BROWN_VIDEO,
        },
      },
      {
        path: '/software-config/prepareEnvExistEnv',
        menuText: 'prepareEnvExistEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arrayDiscoveryExistEnv',
        menuText: 'arrayDiscoveryExistEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arraySetupExistEnv',
        menuText: 'arraySetupExistEnv',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/arraySetupdHCI',
        menuText: 'arraySetupdHCI',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: '/software-config/validation',
        menuText: 'arrayValidation',
        exact: true,
        component: TechDocChecklistPage,
        pageProps: {},
      },

      {
        path: '/software-config/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
